import { tw } from '@/utils/tw';
import BaseArticleDisclosureLabelTheme from 'base/components/ArticleDisclosureLabel/theme';

const ArticleDisclosureLabel = tw.theme({
  extend: BaseArticleDisclosureLabelTheme,
  base: `bg-gray-100 text-gray-600 wings-gray-100 text-ui-md`,
});

export default ArticleDisclosureLabel;
